import type { OnInit } from '@angular/core';
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  standalone: false,
  selector: 'invd-collateral-analyzer-table',
  templateUrl: './collateral-analyzer-table.component.html',
  styleUrls: ['./collateral-analyzer-table.component.scss'],
})
export class CollateralAnalyzerTableComponent implements OnInit {
  @Input() collateralValidatedPoolList: any;
  @Output() displayEditCollateralPopup: EventEmitter<any> = new EventEmitter();
  @Output() deleteSelectedRows: EventEmitter<any> = new EventEmitter();
  @Output() deleteAllRows: EventEmitter<any> = new EventEmitter();
  public isCheckboxSelected = true;
  public isDeleteAllCheckboxSelected = true;
  public deleteAllCheckbox: any;

  ngOnInit() {
    this.isCheckboxSelected = true;
    this.deleteAllCheckbox = false;
  }

  public showEditCollateralPopup(collateralPool, index): void {
    this.displayEditCollateralPopup.emit({
      collateralPool,
      showEditPopup: true,
      index,
    });
  }

  onSingleCheckboxSelection(event, cusip: string, pos: number) {
    this.deleteAllCheckbox = false;
    let isChecked = false;
    isChecked = event.srcElement.checked;
    this.collateralValidatedPoolList.forEach(function (item, index) {
      if (pos === index) {
        item.isSelected = isChecked ? true : false;
      }
    }, this);
    if (this.collateralValidatedPoolList.every((element) => element.isSelected)) {
      this.deleteAllCheckbox = true;
    }
    this.deleteSelectedRows.emit({ poolListForDelete: this.collateralValidatedPoolList });
  }

  onDeleteAllCheckboxSelection(event) {
    let isChecked = false;
    isChecked = event.srcElement.checked;
    this.collateralValidatedPoolList.forEach(function (item) {
      item.isSelected = isChecked ? true : false;
    }, this);

    this.deleteAllRows.emit({ deleteAllCusip: isChecked });
  }

  protected trackByIdentity(_index: number, obj: any) {
    return obj;
  }
}
